import React, { useEffect, useLayoutEffect } from 'react';
import DocumentationListDumb from './DocumentationListDumb';
import queryString from 'query-string';
import { withRouter, useHistory, useLocation } from 'react-router-dom';
import { useUser, useList, useDocument } from 'components/hooks';
import { formatProjectItems } from 'helpers';
import { ErrorScreen } from 'components/common';
import withRequest from 'hoc/withRequest';
import { ROUTES } from 'consts';

const DocumentationListSmart = (props) => {
  const { parameters, filters, setFilters } = useUser();
  const projects = formatProjectItems(parameters);
  const projectsMap = projects.reduce((a, v) => ({ ...a, [v.value]: v}), {});
  const { getContentList, content, error, isLoaded } = useList('documents');
  const document = useDocument();
  const history = useHistory();
  const location = useLocation();
  let { project=filters.project } = queryString.parse(props.location.search);

  const handleListPage = () => {
    if (project !== filters.project) setFilters({ project });
    if (project && !!projectsMap[project]) {
      getContentList({
        query: {
          baseUrl: projectsMap[project].base_url
        },
      });
    } else history.push(`?project=${projects[0].value}`);
  };

  const handleCleanUp = () => {
    document.cleanUpMessage();
  }

  const handleSearch = (data) => {
    const {pathname, search} = location;
    const currentLocation = `${pathname}${search}`;
    let routeToPush = `${ROUTES.DOCUMENTATION_LIST}?project=${data.project}`;
    if (currentLocation === routeToPush) {
      handleListPage();
    } else {
      history.push(routeToPush);
    }
  };

  const handleView = (document) => {
    handleCleanUp();
    history.push(`${ROUTES.DOCUMENTATION_VIEW}/${document.value}/${projectsMap[project].base_url}`);
  };

  useEffect(() => {
    handleListPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [project]);

  useLayoutEffect(() => {
    if (filters.project) handleSearch({ project: filters.project });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      { error ? (
        <ErrorScreen />
      ) : (
        <DocumentationListDumb
          handleSearch={handleSearch}
          handleView={handleView}
          content={content}
          options={projects}
          isLoaded={isLoaded}
          defaultValues={{
            project: !project ? projects[0].value : project,
          }}
        />
      )}
    </>
  );



}

export default withRequest(withRouter(DocumentationListSmart));
